var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8997 21H8.0985C5.0484 21 3 18.8598 3 15.6756V8.3244C3 5.1402 5.0484 3 8.0985 3H15.9006C18.9507 3 21 5.1402 21 8.3244V15.6756C21 18.8598 18.9507 21 15.8997 21Z",
    fill: "#0B1641"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8132 15.1227C10.6222 15.1227 10.4292 15.0497 10.2832 14.9027L7.9092 12.5297C7.6162 12.2367 7.6162 11.7627 7.9092 11.4697C8.2022 11.1767 8.6762 11.1767 8.9692 11.4697L10.8132 13.3117L15.0292 9.0967C15.3222 8.8037 15.7962 8.8037 16.0892 9.0967C16.3822 9.3897 16.3822 9.8637 16.0892 10.1567L11.3432 14.9027C11.1972 15.0497 11.0052 15.1227 10.8132 15.1227Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/CheckboxChecked.0150b8a6e8defe53ff8bfa7528662f77.svg";
export { ForwardRef as ReactComponent };